'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dataTypeGetQueryFragmentMap = exports.dataTypeCardinalityOperatorTypes = exports.inclusionOnly = exports.containmentOnly = exports.stringOperators = exports.comparisonOrEquality = exports.equalityOnly = exports.all = exports.projection = exports.comment = exports.bitwise = exports.array = exports.geospatial = exports.evaluation = exports.element = exports.logical = exports.comparison = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _dataTypeSmallText, _dataTypeLargeText, _dataTypeBoolean, _dataTypeDateTime, _dataTypeDateOnly, _dataTypeReal, _dataTypeInteger, _dataTypeCardinalityO, _dataTypeGetQueryFrag;

exports.getOperatorQueryFragment = getOperatorQueryFragment;
exports.getOperatorSet = getOperatorSet;

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _cardinality = require('./cardinality');

var _dataTypes = require('./dataTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var comparison = exports.comparison = {
    $eq: { value: '$eq', name: 'Equals' },
    $gt: { value: '$gt', name: 'Greater Than' },
    $gte: { value: '$gte', name: 'Greater Than Or Equal To' },
    $lt: { value: '$lt', name: 'Less Than' },
    $lte: { value: '$lte', name: 'Less Than Or Equal To' },
    $ne: { value: '$ne', name: 'Not Equal' },
    $contains: { value: '$contains', name: 'Contains' }, // not a real mongo operator, needs to be implemented using regexp
    $ncontains: { value: '$ncontains', name: 'Does Not Contain' }, // not a real mongo operator, needs to be implemented using regexp
    $in: { value: '$in', name: 'Is Contained In' },
    $nin: { value: '$nin', name: 'Is Not Contained In' }
};

var logical = exports.logical = {
    $or: { value: '$or', name: 'Or' },
    $and: { value: '$and', name: 'And' },
    $not: { value: '$not', name: 'Not' },
    $nor: { value: '$nor', name: 'Equals' }
};

var element = exports.element = {
    $exists: { value: '$exists', name: 'Exists' },
    $type: { value: '$type', name: 'Of Type' }
};

var evaluation = exports.evaluation = {
    $mod: { value: '$mod', name: 'Mod' },
    $regex: { value: '$regex', name: 'Regular Expression' },
    $text: { value: '$text', name: 'Text Search' },
    $where: { value: '$where', name: 'Where' }
};

var geospatial = exports.geospatial = {
    $geoWithin: { value: '$geoWithin', name: 'Geometric Within' },
    $geoIntersects: { value: '$geoIntersects', name: 'Geometric Intersects' },
    $near: { value: '$near', name: 'Geometric Near' },
    $nearSphere: { value: '$nearSphere', name: 'Geometric Near (Spherical)' }
};

var array = exports.array = {
    $all: { value: '$all', name: 'All' },
    $elemMatch: { value: '$elemMatch', name: 'Element Match' },
    $size: { value: '$size', name: 'Size' }
};

var bitwise = exports.bitwise = {
    $bitsAllSet: { value: '$bitsAllSet', name: 'All Bits Set' },
    $bitsAnySet: { value: '$bitsAnySet', name: 'Any Bits Set' },
    $bitsAllClear: { value: '$bitsAllClear', name: 'All Bits Clear' },
    $bitsAnyClear: { value: '$bitsAnyClear', name: 'Any Bits Clear' }
};

var comment = exports.comment = {
    $comment: { value: '$comment', name: 'Comment' }
};

var projection = exports.projection = {
    $: { value: '$', name: 'First Element' },
    $elemMatch: { value: '$elemMatch', name: 'First Element' },
    $meta: { value: '$meta', name: 'Text Score' },
    $slice: { value: '$slice', name: 'Slice' }
};

var all = exports.all = (0, _assign2.default)({}, comparison, logical, element, evaluation, geospatial, array, bitwise, comment, projection);

var equalityOnly = exports.equalityOnly = (0, _lodash.pick)(comparison, ['$eq', '$ne']);
var comparisonOrEquality = exports.comparisonOrEquality = (0, _lodash.pick)(comparison, ['$eq', '$ne', '$gt', '$gte', '$lt', '$lte']);
var stringOperators = exports.stringOperators = (0, _lodash.pick)(comparison, ['$eq', '$ne', '$gt', '$gte', '$lt', '$lte', '$contains', '$ncontains']);
var containmentOnly = exports.containmentOnly = (0, _lodash.pick)(comparison, ['$contains', '$ncontains']);
var inclusionOnly = exports.inclusionOnly = (0, _lodash.pick)(comparison, ['$in', '$nin']);

// default for most value sets.
var dataTypeCardinalityOperatorTypes = exports.dataTypeCardinalityOperatorTypes = (_dataTypeCardinalityO = {}, (0, _defineProperty3.default)(_dataTypeCardinalityO, _dataTypes.dataTypeSmallText, (_dataTypeSmallText = {}, (0, _defineProperty3.default)(_dataTypeSmallText, _cardinality.cardinalityOne, 'stringOperators'), (0, _defineProperty3.default)(_dataTypeSmallText, _cardinality.cardinalityMany, 'inclusionOnly'), _dataTypeSmallText)), (0, _defineProperty3.default)(_dataTypeCardinalityO, _dataTypes.dataTypeLargeText, (_dataTypeLargeText = {}, (0, _defineProperty3.default)(_dataTypeLargeText, _cardinality.cardinalityOne, 'containmentOnly'), (0, _defineProperty3.default)(_dataTypeLargeText, _cardinality.cardinalityMany, 'inclusionOnly'), _dataTypeLargeText)), (0, _defineProperty3.default)(_dataTypeCardinalityO, _dataTypes.dataTypeBoolean, (_dataTypeBoolean = {}, (0, _defineProperty3.default)(_dataTypeBoolean, _cardinality.cardinalityOne, 'equalityOnly'), (0, _defineProperty3.default)(_dataTypeBoolean, _cardinality.cardinalityMany, 'inclusionOnly'), _dataTypeBoolean)), (0, _defineProperty3.default)(_dataTypeCardinalityO, _dataTypes.dataTypeDateTime, (_dataTypeDateTime = {}, (0, _defineProperty3.default)(_dataTypeDateTime, _cardinality.cardinalityOne, 'comparisonOrEquality'), (0, _defineProperty3.default)(_dataTypeDateTime, _cardinality.cardinalityMany, 'inclusionOnly'), _dataTypeDateTime)), (0, _defineProperty3.default)(_dataTypeCardinalityO, _dataTypes.dataTypeDateOnly, (_dataTypeDateOnly = {}, (0, _defineProperty3.default)(_dataTypeDateOnly, _cardinality.cardinalityOne, 'comparisonOrEquality'), (0, _defineProperty3.default)(_dataTypeDateOnly, _cardinality.cardinalityMany, 'inclusionOnly'), _dataTypeDateOnly)), (0, _defineProperty3.default)(_dataTypeCardinalityO, _dataTypes.dataTypeReal, (_dataTypeReal = {}, (0, _defineProperty3.default)(_dataTypeReal, _cardinality.cardinalityOne, 'comparisonOrEquality'), (0, _defineProperty3.default)(_dataTypeReal, _cardinality.cardinalityMany, 'inclusionOnly'), _dataTypeReal)), (0, _defineProperty3.default)(_dataTypeCardinalityO, _dataTypes.dataTypeInteger, (_dataTypeInteger = {}, (0, _defineProperty3.default)(_dataTypeInteger, _cardinality.cardinalityOne, 'comparisonOrEquality'), (0, _defineProperty3.default)(_dataTypeInteger, _cardinality.cardinalityMany, 'inclusionOnly'), _dataTypeInteger)), _dataTypeCardinalityO);

var dataTypeGetQueryFragmentMap = exports.dataTypeGetQueryFragmentMap = (_dataTypeGetQueryFrag = {}, (0, _defineProperty3.default)(_dataTypeGetQueryFrag, _dataTypes.dataTypeSmallText, getGenericOperatorQueryFragment), (0, _defineProperty3.default)(_dataTypeGetQueryFrag, _dataTypes.dataTypeLargeText, getGenericOperatorQueryFragment), (0, _defineProperty3.default)(_dataTypeGetQueryFrag, _dataTypes.dataTypeBoolean, getGenericOperatorQueryFragment), (0, _defineProperty3.default)(_dataTypeGetQueryFrag, _dataTypes.dataTypeDateTime, getGenericOperatorQueryFragment), (0, _defineProperty3.default)(_dataTypeGetQueryFrag, _dataTypes.dataTypeDateOnly, getDateOnlyOperatorQueryFragment), (0, _defineProperty3.default)(_dataTypeGetQueryFrag, _dataTypes.dataTypeReal, getGenericOperatorQueryFragment), (0, _defineProperty3.default)(_dataTypeGetQueryFrag, _dataTypes.dataTypeInteger, getGenericOperatorQueryFragment), _dataTypeGetQueryFrag);

function getDataTypeQueryFragment() {
    var dataType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return dataTypeGetQueryFragmentMap[dataType.toLowerCase()];
}

function getOperatorQueryFragment(operatorName, value, dataType) {
    var handler = getDataTypeQueryFragment(dataType);
    if (!handler) {
        throw new Error('cannot get query fragment handler for ' + dataType);
    }
    return handler(operatorName, value);
}
function getGenericOperatorQueryFragment(operatorName, value) {
    if (operatorName === '$in' && (0, _lodash.isEmpty)(value)) {
        return null;
    }
    if (operatorName === '$eq' && (0, _lodash.isNil)(value)) {
        return null;
    }
    switch (operatorName) {
        case '$contains':
            return { $regex: (0, _lodash.escapeRegExp)(value), $options: 'i' };
        case '$ncontains':
            return { $regex: '^((?!' + (0, _lodash.escapeRegExp)(value) + ').)*$', $options: 'i' };
        case '$in':
            return (0, _defineProperty3.default)({}, operatorName, (0, _lodash.isArray)(value) ? value : []);
        case '$nin':
            return (0, _defineProperty3.default)({}, operatorName, (0, _lodash.isArray)(value) ? value : []);
        default:
            return (0, _defineProperty3.default)({}, operatorName, value);
    }
}

function getDateOnlyOperatorQueryFragment(operatorName, value) {
    switch (operatorName) {
        case '$eq':
            return {
                $gte: (0, _moment2.default)(value).startOf('day').toDate(),
                $lt: (0, _moment2.default)(value).add(1, 'day').startOf('day').toDate()
            };
        case '$ne':
            return {
                $lt: (0, _moment2.default)(value).startOf('day').toDate(),
                $gte: (0, _moment2.default)(value).add(1, 'day').startOf('day').toDate()
            };
        case '$gt':
            return {
                $gte: (0, _moment2.default)(value).add(1, 'day').startOf('day').toDate()
            };
        case '$gte':
            return {
                $gte: (0, _moment2.default)(value).startOf('day').toDate()
            };
        case '$lt':
            return {
                $lt: (0, _moment2.default)(value).startOf('day').toDate()
            };
        case '$lte':
            return {
                $lt: (0, _moment2.default)(value).add(1, 'day').startOf('day').toDate()
            };
        default:
            throw new Error('Dateonly does not support ' + operatorName + ' operator');
    }
}

function getOperatorSet(dataType, cardinality) {
    var mapping = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : dataTypeCardinalityOperatorTypes;

    if (!(0, _lodash.isString)(dataType) || !(0, _lodash.isString)(cardinality)) return null;
    dataType = dataType.toLowerCase();
    cardinality = cardinality.toLowerCase();
    return (0, _lodash.get)(mapping, [dataType, cardinality], null);
}

exports.default = all;